// Removed misplaced observeCartContent() from top-level scope. It is correctly defined as a method in MiniCartManager.
// One Country Global Scripts

// Ensure cartItemData is globally defined
let cartItemData = {};


// Initialize the global gift item count
window.giftItemCount = 0;




// Debounce function
function debounce(fn, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    return new Promise((resolve, reject) => {
      timeoutId = setTimeout(() => {
        try {
          const result = fn.apply(this, args);
          if (result instanceof Promise) {
            result.then(resolve).catch(reject);
          } else {
            resolve(result);
          }
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
  };
}

const productCompareAtCache = {};

function getProductDataByHandle(handle) {
  if (!handle) return Promise.resolve(null);
  if (productCompareAtCache[handle]) return Promise.resolve(productCompareAtCache[handle]);

  return fetch(`/products/${handle}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch product data for ${handle}`);
      }
      return response.json();
    })
    .then(productData => {
      productCompareAtCache[handle] = productData;
      return productData;
    })
    .catch(error => {
      console.error('Error loading compare-at product data:', error);
      return null;
    });
}

async function getCompareAtLinePriceFromItem(item) {
  if (!item || !item.handle || !item.variant_id) return '';

  const productData = await getProductDataByHandle(item.handle);
  if (!productData || !Array.isArray(productData.variants)) return '';

  const matchedVariant = productData.variants.find(variant => String(variant.id) === String(item.variant_id));
  if (!matchedVariant || !matchedVariant.compare_at_price) return '';

  const compareAtLinePrice = (matchedVariant.compare_at_price * item.quantity) / 100;
  return compareAtLinePrice.toFixed(2);
}

class DropdownManager {
  constructor() {
    this.navItems = document.querySelectorAll('.site-nav .first-list-item > a');
    this.activeDropdown = null;
    this.init();
  }

  setDropdownTabbing(dropdown, isEnabled) {
    if (!dropdown) return;
    dropdown
      .querySelectorAll('a, button, input, select, textarea, [tabindex]')
      .forEach((el) => {
        if (isEnabled) {
          const prevTabindex = el.getAttribute('data-prev-tabindex');
          if (prevTabindex !== null) {
            el.setAttribute('tabindex', prevTabindex);
            el.removeAttribute('data-prev-tabindex');
          } else {
            el.removeAttribute('tabindex');
          }
        } else {
          if (!el.hasAttribute('data-prev-tabindex')) {
            const currentTabindex = el.getAttribute('tabindex');
            if (currentTabindex !== null) {
              el.setAttribute('data-prev-tabindex', currentTabindex);
            }
          }
          el.setAttribute('tabindex', '-1');
        }
      });
  }

  init() {
    this.navItems.forEach((navItem, idx) => {
      const dropdown = navItem.nextElementSibling;
      if (!dropdown) return;

      // Ensure dropdown has an id so aria-controls can reference it
      if (!dropdown.id) dropdown.id = `desktop-dropdown-${idx + 1}`;

      // Initial hidden state
      dropdown.hidden = true;
      dropdown.setAttribute('aria-hidden', 'true');
      this.setDropdownTabbing(dropdown, false);

      // Tie trigger to panel
      navItem.setAttribute('aria-controls', dropdown.id);
      navItem.setAttribute('aria-expanded', 'false');
      navItem.setAttribute('aria-haspopup', 'menu'); // optional but better than true

      navItem.addEventListener('focus', () => this.showDropdown(dropdown, navItem));
      navItem.addEventListener('mouseenter', () => this.showDropdown(dropdown, navItem));

      dropdown.addEventListener('mouseenter', () => this.showDropdown(dropdown, navItem));
      dropdown.addEventListener('focusin', () => this.showDropdown(dropdown, navItem));

      navItem.addEventListener('blur', (e) => this.hideDropdownOnBlurOrMouseLeave(e, dropdown, navItem));
      dropdown.addEventListener('focusout', (e) => this.hideDropdownOnBlurOrMouseLeave(e, dropdown, navItem));

      navItem.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!navItem.matches(':hover') && !dropdown.matches(':hover')) {
            this.hideDropdown(dropdown, navItem);
          }
        }, 100);
      });

      dropdown.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!navItem.matches(':hover') && !dropdown.matches(':hover')) {
            this.hideDropdown(dropdown, navItem);
          }
        }, 100);
      });
    });

    document.addEventListener('keydown', (e) => this.handleGlobalKeydown(e));
  }

  showDropdown(dropdown, navItem) {
    this.activeDropdown = { dropdown, navItem };

    dropdown.hidden = false;
    dropdown.setAttribute('aria-hidden', 'false');
    this.setDropdownTabbing(dropdown, true);

    dropdown.classList.add('active');
    navItem.setAttribute('aria-expanded', 'true');
  }

  hideDropdown(dropdown, navItem) {
    this.activeDropdown = null;

    dropdown.classList.remove('active');

    dropdown.hidden = true;
    dropdown.setAttribute('aria-hidden', 'true');
    this.setDropdownTabbing(dropdown, false);

    navItem.setAttribute('aria-expanded', 'false');
  }

  handleGlobalKeydown(e) {
    if (e.key === 'Escape' && this.activeDropdown) {
      const { dropdown, navItem } = this.activeDropdown;
      this.hideDropdown(dropdown, navItem);
      navItem.focus();
    }
  }

  hideDropdownOnBlurOrMouseLeave(e, dropdown, navItem) {
    setTimeout(() => {
      if (!navItem.contains(document.activeElement) && !dropdown.contains(document.activeElement)) {
        this.hideDropdown(dropdown, navItem);
      }
    }, 10);
  }
}

// Initialize DropdownManager
new DropdownManager();

class CookieManager {
  static setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  static getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  static updateUserData(name, gender, size, days) {
    let cookieValue = this.getCookie(name);
    let cookieData = cookieValue ? JSON.parse(cookieValue) : { gender: gender, genderHistory: '', sizeHistory: '' };

    // Update genderHistory
    if (!cookieData['genderHistory']) {
      cookieData['genderHistory'] = [];
    } else {
      cookieData['genderHistory'] = cookieData['genderHistory'].split(',');
    }
    cookieData['genderHistory'].push(gender);
    if (cookieData['genderHistory'].length > 20) {
      cookieData['genderHistory'].shift();
    }

    // Update sizeHistory
    if (!cookieData['sizeHistory']) {
      cookieData['sizeHistory'] = [];
    } else {
      cookieData['sizeHistory'] = cookieData['sizeHistory'].split(',');
    }
    cookieData['sizeHistory'].push(size);
    if (cookieData['sizeHistory'].length > 20) {
      cookieData['sizeHistory'].shift();
    }

    // Calculate majority gender and size
    cookieData['gender'] = this.calculateMajority(cookieData['genderHistory']);
    cookieData['size'] = this.calculateMajority(cookieData['sizeHistory'], true);

    // Convert history arrays back to strings
    cookieData['genderHistory'] = cookieData['genderHistory'].join(',');
    cookieData['sizeHistory'] = cookieData['sizeHistory'].join(',');

    // Update the cookie with the final values
    this.setCookie(name, JSON.stringify(cookieData), days);
  }

  // Calculate the majority in history arrays
  static calculateMajority(historyArray, isSize = false) {
    if (historyArray.length <= 3) return null; // Not enough entries to calculate majority

    let count = historyArray.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});

    let twoThirds = Math.ceil((2 / 3) * historyArray.length);
    let majorityItem = null;

    for (let item in count) {
      if (count[item] >= twoThirds) {
        majorityItem = item;
        break;
      }
    }

    return majorityItem;
  }
}



// Get shipping limit from theme settings
let shippingLimit = document.querySelector('.ocs-minicart').getAttribute('data-shipping-limit');
shippingLimit = parseFloat(shippingLimit).toFixed(2);

// Update header cart count function
function updateHeaderCartCount(itemCount) {
  //console.log('Updating header cart count to:', itemCount); // Log
  document.querySelectorAll('.cart .count').forEach(headerCartCount => {
    if (headerCartCount) {
      headerCartCount.textContent = itemCount === 0 ? '' : itemCount;
    }
    if (itemCount <= 0) {
      headerCartCount.classList.add('empty');
    } else {
      headerCartCount.classList.remove('empty');
    }
  });
}

// Function to count gift items in the cart (items priced $0)
function countGiftItems(cart) {
  window.giftItemCount = cart.items.reduce((count, item) => {
    if (parseFloat(item.price / 100) === 0) {
      count += item.quantity; // Count each quantity of gift items
    }
    return count;
  }, 0);

  console.log(`Number of gift items in cart: ${window.giftItemCount}`);
}

// Function to check if cart total is zero but has items, then clear the cart
async function checkAndClearCartIfTotalIsZero() {
  try {
    // Fetch the cart data
    const cart = await fetch('/cart.js').then(response => response.json());

    // Check if the cart total is 0 and there are items in the cart
    if (cart.total_price === 0 && cart.items.length > 0) {
      console.log('Cart total is $0, but there are items in the cart. Clearing cart now...');
      await clearCart();
    } else {
      console.log('Cart does not meet the criteria for clearing.');
    }

  } catch (error) {
    console.error('Error checking cart total:', error);
  }
}

// Usage example:
// This function can be called after cart updates or page load to ensure consistency.
document.addEventListener('DOMContentLoaded', () => {
  checkAndClearCartIfTotalIsZero();
});


// Global function to fetch cart data and update the mini-cart
function fetchCartData() {
  checkAndClearCartIfTotalIsZero();
  return fetch('/cart.js')
    .then(response => response.json())
    .then(async cart => {
      //console.log('Cart:', cart);
      let cartBody = document.querySelector('.cart-body');
      let cartFooter = document.querySelector('.cart-footer');
      let cartSummary = document.querySelector('.cart-summary');
      let shippingHeaderMessage = document.querySelector('.shipping-header-message');
      let emptyCartContent = document.querySelector('.empty-cart-content');
      let headerCartCount = document.querySelector(".header-cart-count");
      let shippingBarProgress = document.querySelector('.shipping-bar-progress');
      let shippingBar = document.querySelector('.bar');
      let cartDiscountLine = document.querySelector('.discount-ammount');

      // Fetch the dp_user cookie and parse it to get the gender value
      let dpUserCookie = CookieManager.getCookie('dp_user');
      let genderSetting = dpUserCookie ? JSON.parse(dpUserCookie).gender : null;
      //console.log('Gender Setting: ', genderSetting);

      if(genderSetting == 'M') {
        document.querySelectorAll('.mens-upsell-collection').forEach(x => {x.style.display = "flex"});
        document.querySelectorAll('.womens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.unisex-upsell-collection').forEach(x => {x.style.display = "none"});

      } else if (genderSetting == 'W') {
        document.querySelectorAll('.mens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.womens-upsell-collection').forEach(x => {x.style.display = "flex"});
        document.querySelectorAll('.unisex-upsell-collection').forEach(x => {x.style.display = "none"});

      } else {
        document.querySelectorAll('.mens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.womens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.unisex-upsell-collection').forEach(x => {x.style.display = "flex"});

      }

      // Check if the cart is empty
      if (cart.items.length === 0) {
        //console.log('Cart is empty.');
        cartBody.classList.add('empty');
        if (emptyCartContent) emptyCartContent.style.display = "block";
        if (cartFooter) cartFooter.style.display = 'none';
        if (cartSummary) cartSummary.style.display = 'none';
        if (headerCartCount) headerCartCount.innerHTML = '(0 Items)';
        if (shippingHeaderMessage) {
          shippingHeaderMessage.textContent = `FREE SHIPPING ON ORDERS $${shippingLimit} OR MORE.`;
          shippingHeaderMessage.style.display = "none";
        }
        if (shippingBarProgress) {
          shippingBarProgress.style.width = '0%';
          shippingBar.style.display = "none";
        }
        
        updateHeaderCartCount(0);
        return;
      } else {
        cartBody.classList.remove('empty');
        if (cartSummary) cartSummary.style.display = 'block';
        if (emptyCartContent) emptyCartContent.style.display = "none";
        if (shippingBar) shippingBar.style.display = "block";
        if (shippingHeaderMessage) shippingHeaderMessage.style.display = "block";
        if (cartFooter) cartFooter.style.display = 'block';
      }

      const compareAtLinePrices = await Promise.all(cart.items.map(item => getCompareAtLinePriceFromItem(item)));

      // Update the stored cart item data with new data from the cart
      cart.items.forEach((item, index) => {
        let variantId = item.variant_id;
        cartItemData[variantId] = {
          num: index, // Assigning the index directly from the loop
          id: `CartItem-${index + 1}`, // Using index + 1 for unique IDs if needed
          shortname: item.product_title,
          price: item.price,
          inv: item.inventory_quantity,
          featured_image: item.featured_image,
          url: item.url,
          title: item.product_title,
          options: item.options_with_values.map(option => ({
            name: option.name,
            value: option.value
          })),
          discounts: item.discounts.map(discount => discount.title),
          quantity: item.quantity,
          originalLinePrice: (item.original_line_price / 100).toFixed(2),
          compareAtLinePrice: compareAtLinePrices[index]
        };
        //console.log('item ');
        //console.log(item.product);
      });

      let newTotalDiscount = (cart.total_discount / 100).toFixed(2);
      if(cartDiscountLine){
        cartDiscountLine.textContent = '-$' + newTotalDiscount;
      }
      
      let newCartTotal = (cart.total_price / 100).toFixed(2);
      document.querySelector('.cart-total-value').textContent = '$' + newCartTotal;
      headerCartCount.innerHTML = `(${cart.item_count} Item${cart.item_count > 1 ? 's' : ''})`;

      if (emptyCartContent) emptyCartContent.style.display = 'none';
      if (cartSummary) cartSummary.style.display = 'block';

      // Update shipping progress if necessary
      updateShipping(newCartTotal, shippingLimit);
      updateHeaderCartCount(cart.item_count); // Update header cart count

      // Recreate the HTML for <cart-items>
      renderCartItems();

      // Count and display the number of gift items
      countGiftItems(cart);

      return cart;
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Function to update shipping progress
function updateShipping(cartTotal, shippingLimit) {
  shippingLimit = parseFloat(shippingLimit).toFixed(2); // Ensure it's a number with two decimal places
  let freeShippingPercent = ((cartTotal / shippingLimit) * 100).toFixed(0);
  let progressBar = document.querySelector(".shipping-bar-progress");
  let shippingSummaryText = document.querySelector(".shipping-type");
  let shippingHeader = document.querySelector(".shipping-header-message");
  if (freeShippingPercent >= 100) {
    freeShippingPercent = 100;
  }
  progressBar.style.width = freeShippingPercent + "%";
  if (freeShippingPercent >= 100) {
    shippingSummaryText.innerHTML = "<span>Free Shipping!</span>";
    shippingHeader.innerHTML = "YOU'VE EARNED FREE SHIPPING!";
  } else {
    shippingSummaryText.textContent = "Calculated in Checkout";
    if (freeShippingPercent == 0) {
      shippingHeader.innerHTML = "FREE SHIPPING ON ORDERS $" + shippingLimit + " OR MORE.";
    } else {
      let neededAmount = (shippingLimit - cartTotal).toFixed(2);
      shippingHeader.innerHTML = "ADD $" + neededAmount + " OR MORE TO GET FREE SHIPPING!";
    }
  }
}
// Function to capture existing cart items and store their data
function captureCartItems() {
  document.querySelectorAll('.cart-item').forEach(cartItem => {
    let variantId = cartItem.getAttribute('data-id');
    let imageElement = cartItem.querySelector('.item-image img');
    let imageSrc = imageElement ? imageElement.src : '';
    let imageAlt = imageElement ? imageElement.alt : '';
    let imageAspectRatio = imageElement ? (imageElement.naturalWidth / imageElement.naturalHeight) : 1;
    let itemNameElement = cartItem.querySelector('.item-name');
    let itemName = itemNameElement ? itemNameElement.textContent.trim() : '';

    const itemPriceElement = cartItem.querySelector('.item-price');
    const salePriceElement = cartItem.querySelector('.item-price .price-item--sale');
    const comparePriceElement = cartItem.querySelector('.item-price .price-item--original');
    const endPriceElement = cartItem.querySelector('.price--end');
    let originalLinePrice = '';
    let compareAtLinePrice = '';

    if (salePriceElement) {
      originalLinePrice = salePriceElement.textContent.replace(/[^0-9.]/g, '');
    } else if (itemPriceElement) {
      originalLinePrice = itemPriceElement.textContent.replace(/[^0-9.]/g, '');
    } else if (endPriceElement) {
      originalLinePrice = endPriceElement.textContent.replace(/[^0-9.]/g, '');
    } else {
      console.warn(`Neither item price nor end price found for cart item with variant ID ${variantId}.`);
    }

    if (comparePriceElement) {
      compareAtLinePrice = comparePriceElement.textContent.replace(/[^0-9.]/g, '');
    }

    cartItemData[variantId] = {
      num: cartItem.getAttribute('data-num'),
      id: cartItem.getAttribute('id'),
      shortname: cartItem.getAttribute('data-shortname'),
      price: cartItem.getAttribute('data-price'),
      inv: cartItem.getAttribute('data-inv'),
      image: imageSrc,
      imageAlt: imageAlt,
      imageAspectRatio: imageAspectRatio,
      url: itemNameElement ? itemNameElement.href : '',
      title: itemName,
      options: [...cartItem.querySelectorAll('.product-option')].map(option => {
        let dtElement = option.querySelector('dt');
        let ddElement = option.querySelector('dd');
        return {
          name: dtElement ? dtElement.textContent.trim() : '',
          value: ddElement ? ddElement.textContent.trim() : ''
        };
      }),
      discounts: [...cartItem.querySelectorAll('.discounts__discount')].map(discount => discount.textContent.trim()),
      quantity: cartItem.querySelector('.quantity__input').value,
      originalLinePrice: originalLinePrice, // Add the calculated price here
      compareAtLinePrice: compareAtLinePrice
    };
  });
}

let quantitySelector = ``;
let productType;

// Function to recreate the HTML for <cart-items> based on the updated object
function renderCartItems() {
  let cartItemsContainer = document.querySelector('cart-items');
  cartItemsContainer.innerHTML = '';

  let keys = Object.keys(cartItemData);

  keys.sort((a, b) => {
    let priceA = parseFloat(cartItemData[a].originalLinePrice);
    let priceB = parseFloat(cartItemData[b].originalLinePrice);
    return (priceA <= 0.01) - (priceB <= 0.01); // Push free items (price <= 0.01) to the end
  });

  for (let i = 0; i < keys.length; i++) {
    let variantId = keys[i];
    let item = cartItemData[variantId];
    let index = i + 1;  // This gives you a 1-based index

    let featuredImage = item.featured_image || {
      url: item.image,
      alt: item.imageAlt,
      aspect_ratio: item.imageAspectRatio || 1
    };

    var thisItemPrice = parseFloat(item.originalLinePrice);
    const hasSaleCompare = item.compareAtLinePrice && parseFloat(item.compareAtLinePrice) > parseFloat(item.originalLinePrice);

    if (thisItemPrice <= 0.01) {
      quantitySelector = `<div class="lock-quantity"><strong style="display:none;">${item.quantity}</strong></div>`;
      productType = 'free-product';
      
    } else {
      quantitySelector = `
      <div class="cart-item__quantity">
        <div class="cart-item__quantity-wrapper">
          <label class="visually-hidden" for="Quantity-${index}">Quantity</label>
          <quantity-input class="quantity">
            <button class="quantity_btn btn-minus" tabindex="0" name="minus" type="button" aria-label="Decrease quantity for ${item.title}"><span class="visually-hidden">Decrease quantity for ${item.title}</span>-</button>
            <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" aria-label="${item.quantity} item of ${item.title} in cart." id="Quantity-${index}" data-index="${index}" readonly>
            <button class="quantity_btn btn-plus" tabindex="0" name="plus" type="button" aria-label="Increase quantity for ${item.title}"><span class="visually-hidden">Increase quantity for ${item.title}</span>+</button>
          </quantity-input>
        </div>
      </div>`;
      productType = 'standard-product';
    }
    
    let cartItemHTML = `
      <div class="cart-item ${productType}" 
        data-num="${index}" 
        id="${item.id}" 
        data-id="${variantId}" 
        data-shortname="${item.shortname}" 
        data-price="${item.price}"
        data-inv="${item.inv}">
        <div class="item-image">
          <img src="${featuredImage.url}&width=200" class="cart-img" alt="" role="presentation" aria-hidden="true" loading="lazy" width="150" height="${Math.ceil(200 / featuredImage.aspect_ratio)}">
        </div>
        <div class="item-details">
          <div class="item-contain">
            <a href="${item.url}" class="item-name">${item.title.toLowerCase()}</a>
            <div class="item-qualities">
              <dl class="item-options">
                ${item.options.map(option => `
                <div class="product-option">
                  <dt><span class="visually-hidden">${option.name}</span><span class="sep"> / </span></dt>
                  <dd>${option.value}</dd>
                </div>`).join('')}
              </dl>
              <ul class="discounts list-unstyled" role="list">
                ${item.discounts.map(discount => `<li class="discounts__discount">${discount}</li>`).join('')}
              </ul>
            </div>
            ${quantitySelector}
          </div>
        </div>
        <div class="item-totals">
          <div class="item-price">${hasSaleCompare ? `<s class="price-item price-item--original">$${parseFloat(item.compareAtLinePrice).toFixed(2)}</s>` : ''}<span class="price-item price-item--sale">$${parseFloat(item.originalLinePrice).toFixed(2)}</span></div>
          <div class="item-price-loading" style="display:none;">
              <img width="30" height="30" class="icon-loading" loading="lazy" src="https://cdn.shopify.com/s/files/1/2559/9416/files/ico-loading.gif?v=1720224887" alt="Loading" />
          </div>
          <div class="item-error"></div>
          <div class="remove-this-item" id="Remove-${index}" data-index="${index}">
            <button
              type="button"
              class="remove-btn"
              aria-label="Remove ${item.title} from cart"
            >
              Remove
            </button>
          </div>
        </div>
      </div>`;
    cartItemsContainer.insertAdjacentHTML('beforeend', cartItemHTML);
  }
}
const inflight = new Map();

const updateCart = debounce(async (variant_id, requestedQuantity) => {
  if (inflight.get(variant_id)) return; // ignore while running

  inflight.set(variant_id, true);
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const lineItem = cart.items.find(i => String(i.variant_id) === String(variant_id));
    if (!lineItem?.key) return;

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItem.key, quantity: requestedQuantity })
    });
    if (!res.ok) return;

    const updatedCart = await fetchCartData();
    updateHeaderCartCount(updatedCart.item_count);

    const updatedLineItem = updatedCart.items.find(i => String(i.variant_id) === String(variant_id));
    const updatedQuantity = updatedLineItem ? updatedLineItem.quantity : 0;

    const cartItemEl = document.querySelector(`.cart-item[data-id="${variant_id}"]`);
    if (cartItemEl) {
      const itemError = cartItemEl.querySelector('.item-error');
      if (requestedQuantity > updatedQuantity) {
        itemError.textContent = "Sorry! That's all we have available.";
        itemError.style.display = "block";
      } else {
        itemError.textContent = "";
        itemError.style.display = "none";
      }
    }
  } finally {
    inflight.delete(variant_id);
  }
}, 300);


// Swiper - Collection
var collectionSwiper = new Swiper(".collectionSwiper", {
  navigation: {
    nextEl: '.collectionSwiper-next',
    prevEl: '.collectionSwiper-prev'
  },
  // Default parameters
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 20,
  slidesPerGroupAuto: false,
  centeredSlides: true,
  noSwipingSelector: '.btn',
  watchSlidesVisibility: true,
  watchOverflow: true,
  allowTouchMove: false
});

// Desktop Product Swiper
$('.desktopProductSwiper .gallery-thumbs .product__media:first-child').addClass('selected');
$('.desktopProductSwiper .gallery-thumbs .product__media').on('click', function() {
  var id = $(this).data('id');
  $('.desktopProductSwiper .gallery-viewer .product__media').hide();
  $('.desktopProductSwiper .gallery-viewer .product__media[data-id="'+ id +'"]').show();
  $('.desktopProductSwiper .gallery-thumbs .product__media').removeClass('selected');
  $(this).addClass('selected');
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

});





// General function to clear all items from the cart
async function clearCart() {
  try {
    const data = { updates: {} };

    // Set each cart item's quantity to 0
    const cart = await fetch('/cart.js').then(response => response.json());
    cart.items.forEach(item => {
      data.updates[item.id] = 0;
    });

    // Make request to update the cart
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Failed to clear the cart');
    }

    console.log('Cart cleared successfully');

    // Remove all .cart-item elements inside cart-items
    document.querySelectorAll('cart-items .cart-item').forEach(item => item.remove());
    console.log(response);

    // Optionally call functions to re-render or fetch the cart data
    //renderCartItems(); - this was causing problems when there was only a $0 item in cart that was cleared, it was putting the UI back.
    fetchCartData();

  } catch (error) {
    console.error('Error clearing the cart:', error);
  }
}

function mobileMenuHandler(event) {
  // Only process click events or keydown events where Enter was pressed
  if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
    
  }
}



document.addEventListener('DOMContentLoaded', function() {

  captureCartItems();

  document.addEventListener('click', function(e) {
    if (e.target.closest('.quantity_btn')) {
      e.preventDefault();
      const cartItem = e.target.closest('.cart-item');
      console.log(cartItem);
      if (!cartItem) return; // Safety check
      
      const itemPrice = cartItem.querySelector('.item-price');
      const itemPriceLoading = cartItem.querySelector('.item-price-loading');
      const variant_id = cartItem.dataset.id;
      const variant_inv = cartItem.dataset.inv;
      let orr_quantity = parseInt(cartItem.querySelector('.quantity__input').value);
      console.log('orr_quantity: '+orr_quantity);
      let quantity = orr_quantity;
  
      // Show loading indicator and hide item price
      if (itemPrice) itemPrice.style.display = 'none';
      if (itemPriceLoading) itemPriceLoading.style.display = 'block';
      console.log(variant_inv);
      if (e.target.closest('.btn-plus')) {
        if (variant_inv === "undefined" || variant_inv > orr_quantity) {
          quantity = orr_quantity + 1;
          cartItem.querySelector('.item-error').textContent = ""; // Clear any error messages
        } else {
          cartItem.querySelector('.item-error').textContent = "Not enough inventory available.";
          quantity = orr_quantity; // Prevent changing the quantity
        }
      } else if (e.target.closest('.btn-minus') && orr_quantity > 1) {
        quantity = orr_quantity - 1;
        cartItem.querySelector('.item-error').textContent = ""; // Clear error messages when decrementing
      }
      console.log('quantity: '+quantity);
  
      // Call updateCart, ensuring it is called once
      if (quantity !== orr_quantity) { // Prevent unnecessary calls if the quantity has not changed
        
        updateCart(variant_id, quantity).finally(() => {
          // Hide loading indicator and show item price again
          if (itemPrice) itemPrice.style.display = 'block';
          if (itemPriceLoading) itemPriceLoading.style.display = 'none';
        });
      } else {
        // Hide loading indicator if no update occurs
        if (itemPrice) itemPrice.style.display = 'block';
        if (itemPriceLoading) itemPriceLoading.style.display = 'none';
      }
    }
  });

  // Remove This Item
  document.addEventListener('click', async (e) => {
    const removeButton = e.target.closest('.remove-this-item');
    if (!removeButton) return;
    try {
      const cartItem = removeButton.closest('.cart-item');
      const itemId = cartItem.dataset.id;
      const data = { updates: { [itemId]: 0 } };
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        throw new Error('Failed to update the cart');
      }
      const result = await response.json();
      delete cartItemData[itemId];
      renderCartItems();
      fetchCartData();
  
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  });

  fetchCartData();
});


class MiniCartManager {
  constructor() {
    this.minicartSection = document.querySelector('#shopify-section-ocs-minicart');
    this.minicart = document.querySelector('#ocs-minicart');

    // Openers live OUTSIDE the dialog (header button, etc.)
    // Closers live INSIDE the dialog (close button)
    this.openButtons = document.querySelectorAll('.toggle-minicart:not([data-minicart-close])');
    this.closeButtons = this.minicart ? this.minicart.querySelectorAll('[data-minicart-close]') : [];

    this.body = document.body;

    this.focusableElements = [];
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;

    this.lastFocused = null;

    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.boundHandleFocusIn = this.handleFocusIn.bind(this);

    this.init();
  }

  init() {
    if (!this.minicart || !this.minicartSection) return;
    this.setInitialState();
    this.addToggleListeners();
    this.observeCartContent();
  }

  setInitialState() {
    // If you use CSS to hide/show, keep aria-hidden in sync
    this.minicart.setAttribute('aria-hidden', 'true');
    this.minicart.setAttribute('tabindex', '-1');
    this.minicartSection.classList.remove('open');
    this.body.classList.remove('noscroll');

    this.openButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));

    this.minicartSection.addEventListener('click', (e) => {
      if (e.target === this.minicartSection) this.closeMiniCart();
    });
  
  }

  setInertState(isOpen) {
    // Only inert the real page content behind the dialog.
    // IMPORTANT: do not aria-hidden large regions.
    const header = document.querySelector('.primary-header');
    const main = document.querySelector('#MainContent');

    if (header) isOpen ? header.setAttribute('inert', '') : header.removeAttribute('inert');
    if (main) isOpen ? main.setAttribute('inert', '') : main.removeAttribute('inert');
  }

  isActuallyVisible(el) {
    if (!el) return false;

    // Hidden via attribute or ancestor
    if (el.hidden) return false;
    if (el.closest('[hidden]')) return false;

    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    // Not in layout flow (often means hidden by ancestor)
    // Fixed elements can have offsetParent null but still be visible.
    if (el.offsetParent === null && style.position !== 'fixed') return false;

    return true;
  }

  getFocusableElements() {
    // Use the entire minicart section, not just .cart-body, to include footer buttons
    const nodes = this.minicartSection.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    return Array.from(nodes).filter(el => this.isActuallyVisible(el));
  }

  refreshFocusTrap() {
    this.focusableElements = this.getFocusableElements();
    // Debugging output for introspection
    if (window.DEBUG_MINICART_FOCUS) {
      console.log('[MiniCartManager] refreshFocusTrap: focusableElements:', this.focusableElements);
      this.focusableElements.forEach((el, idx) => {
        console.log(`  [${idx}]`, el, 'tabindex:', el.getAttribute('tabindex'), 'type:', el.type || el.tagName, 'aria-label:', el.getAttribute('aria-label'), 'visible:', this.isActuallyVisible(el));
      });
    }
    this.firstFocusableElement = this.focusableElements[0] || this.minicart;
    this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1] || this.minicart;
  }

  handleKeydown(e) {
    const isOpen = this.minicart.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.closeMiniCart();
      return;
    }

    if (e.key !== 'Tab') return;

    this.refreshFocusTrap();

    // If nothing focusable, keep focus on dialog
    if (this.focusableElements.length === 0) {
      e.preventDefault();
      this.minicart.focus();
      return;
    }

    // Trap focus
    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusableElement || document.activeElement === this.minicart) {
        e.preventDefault();
        this.lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusableElement) {
        e.preventDefault();
        this.firstFocusableElement.focus();
      }
    }
  }

  handleFocusIn(e) {
    const isOpen = this.minicart.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    // If focus is inside, fine
    if (this.minicart.contains(e.target)) return;

    // If focus tries to escape, pull it back
    this.refreshFocusTrap();
    (this.firstFocusableElement || this.minicart).focus();
  }

  openMiniCart(triggerEl) {
    if (this.minicart.getAttribute('aria-hidden') === 'false') return;

    this.lastFocused = triggerEl || document.activeElement;

    this.minicartSection.classList.add('open');
    this.minicart.setAttribute('aria-hidden', 'false');
    this.body.classList.add('noscroll');

    // Optional: keep opener aria-expanded correct
    if (this.lastFocused && this.lastFocused.setAttribute) {
      this.lastFocused.setAttribute('aria-expanded', 'true');
    }

    this.setInertState(true);

    document.addEventListener('keydown', this.boundHandleKeydown);
    document.addEventListener('focusin', this.boundHandleFocusIn);

    this.refreshFocusTrap();
    (this.firstFocusableElement || this.minicart).focus();
  }

  closeMiniCart() {
    if (this.minicart.getAttribute('aria-hidden') === 'true') return;

    this.minicartSection.classList.remove('open');
    this.minicart.setAttribute('aria-hidden', 'true');
    this.body.classList.remove('noscroll');

    this.setInertState(false);

    document.removeEventListener('keydown', this.boundHandleKeydown);
    document.removeEventListener('focusin', this.boundHandleFocusIn);

    // Optional: restore opener aria-expanded
    if (this.lastFocused && this.lastFocused.setAttribute) {
      this.lastFocused.setAttribute('aria-expanded', 'false');
    }

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }
  }

  addToggleListeners() {
    // Openers (outside dialog)
    this.openButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openMiniCart(btn);
      });

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openMiniCart(btn);
        }
      });
    });

    // Closers (inside dialog)
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeMiniCart();
      });

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.closeMiniCart();
        }
      });
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  if (window.miniCartManager) return;
  window.miniCartManager = new MiniCartManager();
});




/* HEADER MANAGER */

class HeaderManager {
  constructor() {
    this.mobileToggleOn = document.querySelector('.mobile-toggle-on');
    this.mobileToggleOff = document.querySelector('.mobile-toggle-off');
    this.mobileMenu = document.querySelector('#mobile-menu');
    this.body = document.body;
    this.levelOneItems = document.querySelectorAll('.level-one');
    this.submenus = document.querySelectorAll('.submenu-slide');

    this.init();
  }

  init() {
    this.setInitialMenuState();
    this.disableAllTabbing(this.mobileMenu);
    this.addMobileMenuListeners();
    this.addLevelOneListeners();
    this.addBackLinkListeners();
  }

  setInitialMenuState() {
    this.mobileMenu.hidden = true;  // Ensure the menu is hidden initially
    this.mobileMenu.setAttribute('aria-hidden', 'true');
    this.mobileToggleOn.setAttribute('aria-expanded', 'false');
  }

  disableTabbing(container) {
    container.querySelectorAll('a, button, input, select, textarea').forEach(el => {
      el.setAttribute('tabindex', '-1');
    });
  }

  enableTabbing(container) {
    container.querySelectorAll('a, button, input, select, textarea').forEach(el => {
      el.removeAttribute('tabindex');
    });
  }

  disableAllTabbing(container) {
    this.disableTabbing(container);

    this.submenus.forEach(submenu => {
      submenu.hidden = true; // add this
      submenu.setAttribute('aria-hidden', 'true');
      this.disableTabbing(submenu);
    });
  }

  openMobileMenu() {
    this.mobileMenu.hidden = false;
    this.mobileMenu.setAttribute('aria-hidden', 'false');
    this.mobileMenu.setAttribute('open', '');
    this.mobileToggleOn.setAttribute('aria-expanded', 'true');
    this.body.classList.add('noscroll');

    this.enableTabbing(this.mobileMenu);  // Enable tabbing for the entire mobile menu
    this.mobileMenu.querySelector('a, button, input').focus();  // Set initial focus
  }

  closeMobileMenu() {
    this.mobileMenu.hidden = true;
    this.mobileMenu.setAttribute('aria-hidden', 'true');
    this.mobileMenu.removeAttribute('open');
    this.mobileToggleOn.setAttribute('aria-expanded', 'false');
    this.body.classList.remove('noscroll');

    this.disableAllTabbing(this.mobileMenu);  // Disable tabbing for all elements inside the menu
    this.mobileToggleOn.focus();  // Return focus to the menu open button
  }

  openSubmenu(submenu, triggerEl) {
    submenu.hidden = false;
    submenu.setAttribute('aria-hidden', 'false');
    this.enableTabbing(submenu);

    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');

    submenu.querySelector('button, a')?.focus();
  }

  closeSubmenu(submenu, triggerEl) {
    submenu.hidden = true;
    submenu.setAttribute('aria-hidden', 'true');
    this.disableTabbing(submenu);

    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
  }

  addMobileMenuListeners() {
    // Toggle on button click
    this.mobileToggleOn.addEventListener('click', () => this.openMobileMenu());
    this.mobileToggleOff.addEventListener('click', () => this.closeMobileMenu());

    // Close the menu on "Escape"
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.mobileMenu.getAttribute('aria-hidden') === 'false') {
        this.closeMobileMenu();
      }
    });
  }

  addLevelOneListeners() {
    this.levelOneItems.forEach(item => {
      item.addEventListener('click', (e) => {
        this.handleLevelOneInteraction(e, item);
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.handleLevelOneInteraction(e, item);
        }
      });
    });
  }

  handleLevelOneInteraction(e, item) {
    const submenu = item.nextElementSibling;

    if (submenu && submenu.classList.contains('submenu-slide')) {
      const isHidden = submenu.hidden || submenu.getAttribute('aria-hidden') === 'true';

      if (isHidden) {
        this.openSubmenu(submenu, item);
      } else {
        this.closeSubmenu(submenu, item);
      }
    }
  }

  addBackLinkListeners() {
    this.submenus.forEach(submenu => {
      const backLink = submenu.querySelector('.back-link');

      if (backLink) {
        backLink.addEventListener('click', () => {
          const opener = this.mobileMenu.querySelector(`[aria-controls="${submenu.id}"]`);
          this.closeSubmenu(submenu, opener);
          opener?.focus();
        });

        backLink.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const opener = this.mobileMenu.querySelector(`[aria-controls="${submenu.id}"]`);
            this.closeSubmenu(submenu, opener);
            opener?.focus();
          }
        });
      }
    });
  }

  focusParentSubmenu(submenu) {
    if (!submenu.id) return;

    const opener = this.mobileMenu.querySelector(`[aria-controls="${submenu.id}"]`);
    opener?.focus();
  }

  addNestedSubmenuListeners() {
    document.querySelectorAll('.level-two').forEach(levelTwoItem => {
      levelTwoItem.addEventListener('click', (e) => {
        const nestedSubmenu = levelTwoItem.nextElementSibling;

        if (nestedSubmenu && nestedSubmenu.classList.contains('submenu-slide')) {
          this.openSubmenu(nestedSubmenu, levelTwoItem);
        }
      });

      levelTwoItem.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const nestedSubmenu = levelTwoItem.nextElementSibling;

          if (nestedSubmenu && nestedSubmenu.classList.contains('submenu-slide')) {
            this.openSubmenu(nestedSubmenu, levelTwoItem);
          }
        }
      });
    });
  }

  addAnchorLinkListeners() {
    this.mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          // Prevent submenu handling if it's a direct link without a submenu
          if (!link.nextElementSibling || !link.nextElementSibling.classList.contains('submenu-slide')) {
            e.preventDefault();  // Fix Enter behavior by allowing the link navigation
            window.location.href = link.href;
          }
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerManager = new HeaderManager();
  headerManager.addNestedSubmenuListeners();
  headerManager.addAnchorLinkListeners();  // Added to fix the navigation issue on Enter
});


/* SEARCH DRAWER */


/* SEARCH DRAWER */
class SearchDrawerManager {
  constructor() {
    this.searchDrawer = document.querySelector('#search-drawer');
    this.openSearchButton = document.querySelector('.toggle-search.open-search');
    this.closeInsideButton = this.searchDrawer?.querySelector('[data-search-close]');
    this.searchInput = this.searchDrawer?.querySelector('.search-form-input');

    this.primaryHeader = document.querySelector('.primary-header');
    this.mainContent = document.querySelector('#MainContent');

    this.lastFocused = null;

    this.focusableElements = [];
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;

    this.boundHandleKeydown = this.handleKeydown.bind(this);

    this.init();
  }

  init() {
    if (!this.searchDrawer || !this.openSearchButton) return;

    this.setInitialState();
    this.addToggleListeners();
  }

  setInitialState() {
    this.searchDrawer.setAttribute('aria-hidden', 'true');
    this.searchDrawer.hidden = true;
    this.openSearchButton.setAttribute('aria-expanded', 'false');
  }

  setInertState(isOpen) {
    // Keep interaction from leaking behind the dialog.
    // IMPORTANT: do NOT set aria-hidden on large page regions.
    if (this.primaryHeader) {
      if (isOpen) this.primaryHeader.setAttribute('inert', '');
      else this.primaryHeader.removeAttribute('inert');
    }

    if (this.mainContent) {
      if (isOpen) this.mainContent.setAttribute('inert', '');
      else this.mainContent.removeAttribute('inert');
    }
  }

  setFocusTrap() {
    this.focusableElements = Array.from(
      this.searchDrawer.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );

    this.firstFocusableElement = this.focusableElements[0] || null;
    this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1] || null;
  }

  handleKeydown(e) {
    const isOpen = this.searchDrawer.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.closeSearchDrawer();
      return;
    }

    if (e.key !== 'Tab') return;

    // Focus trap
    if (!this.firstFocusableElement || !this.lastFocusableElement) return;

    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusableElement) {
        e.preventDefault();
        this.lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusableElement) {
        e.preventDefault();
        this.firstFocusableElement.focus();
      }
    }
  }

  openSearchDrawer() {
    // Prevent double-open
    if (this.searchDrawer.getAttribute('aria-hidden') === 'false') return;

    this.lastFocused = document.activeElement;

    this.searchDrawer.hidden = false;
    this.searchDrawer.setAttribute('aria-hidden', 'false');
    this.openSearchButton.setAttribute('aria-expanded', 'true');

    this.setInertState(true);
    this.setFocusTrap();

    // Focus the input (or the dialog if input missing)
    if (this.searchInput) this.searchInput.focus();
    else this.searchDrawer.focus();

    document.addEventListener('keydown', this.boundHandleKeydown);
  }

  closeSearchDrawer() {
    // Prevent double-close
    if (this.searchDrawer.getAttribute('aria-hidden') === 'true') return;

    this.searchDrawer.hidden = true;
    this.searchDrawer.setAttribute('aria-hidden', 'true');
    this.openSearchButton.setAttribute('aria-expanded', 'false');

    this.setInertState(false);

    document.removeEventListener('keydown', this.boundHandleKeydown);

    // Return focus to where the user was
    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    } else {
      this.openSearchButton.focus();
    }
  }

  toggleSearchDrawer() {
    const isOpen = this.searchDrawer.getAttribute('aria-hidden') === 'false';
    isOpen ? this.closeSearchDrawer() : this.openSearchDrawer();
  }

  addToggleListeners() {
    // Click to open/close
    this.openSearchButton.addEventListener('click', () => this.toggleSearchDrawer());

    // Keyboard activation safety (Enter/Space)
    this.openSearchButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggleSearchDrawer();
      }
    });

    // Close button inside dialog
    if (this.closeInsideButton) {
      this.closeInsideButton.addEventListener('click', () => this.closeSearchDrawer());
      this.closeInsideButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.closeSearchDrawer();
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SearchDrawerManager();
});

function getKlaviyoFieldLabel(field) {
  if (field.getAttribute('aria-label') || field.getAttribute('aria-labelledby')) return null;

  const type = (field.getAttribute('type') || '').toLowerCase();
  if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'image') return null;

  if (type === 'email') return 'Email address';
  if (type === 'tel') return 'Phone number';

  const placeholder = field.getAttribute('placeholder');
  if (placeholder) return placeholder.trim();

  const name = field.getAttribute('name');
  if (name) {
    return name
      .replace(/\[|\]/g, ' ')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return 'Form field';
}

function applyKlaviyoFieldLabels(root = document) {
  const containers = root.querySelectorAll('[class*="klaviyo-form"]');
  const escapeId = (id) => (window.CSS && CSS.escape ? CSS.escape(id) : id);

  containers.forEach((container) => {
    container.querySelectorAll('input, select, textarea').forEach((field) => {
      if (!(field instanceof HTMLElement)) return;
      if (field.tagName === 'INPUT') {
        const type = (field.getAttribute('type') || '').toLowerCase();
        if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'image') return;
      }

      const fieldId = field.getAttribute('id');
      if (fieldId) {
        const label = container.querySelector(`label[for="${escapeId(fieldId)}"]`);
        if (label) return;
      }

      const labelText = getKlaviyoFieldLabel(field);
      if (labelText) field.setAttribute('aria-label', labelText);
    });
  });
}

function applyYotpoBadgeA11y(root = document) {
  const icons = root.querySelectorAll(
    'svg.yotpo-shop-badge, svg.yotpo-answers-extra-arrow, svg.PREV, svg.NEXT'
  );
  const paginationPaths = root.querySelectorAll('.yotpo-pagination-icon');
  const paginationSvgs = Array.from(paginationPaths)
    .map((path) => path.closest('svg'))
    .filter((svg) => svg instanceof SVGElement);
  const allIcons = [...icons, ...paginationSvgs];

  if (!allIcons.length) return;

  allIcons.forEach((icon) => {
    if (!(icon instanceof SVGElement)) return;
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('role', 'presentation');
    icon.setAttribute('focusable', 'false');
    if (icon.hasAttribute('aria-label')) icon.removeAttribute('aria-label');
  });
}

function applyYotpoReadMoreLabels(root = document) {
  const buttons = root.querySelectorAll('button.yotpo-read-more');
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    const expanded = button.getAttribute('aria-expanded');
    const baseLabel = expanded === 'true' ? 'Read less review' : 'Read more review';
    button.setAttribute('aria-label', baseLabel);
  });
}

function applyYotpoCarouselArrowLabels(root = document) {
  const arrows = root.querySelectorAll('.yotpo-carousel-arrow');
  if (!arrows.length) return;

  arrows.forEach((arrow) => {
    if (!(arrow instanceof HTMLElement)) return;
    const isLeft = arrow.classList.contains('glide__arrow--left');
    const label = isLeft ? 'Left arrow' : 'Right arrow';
    arrow.setAttribute('aria-label', label);
  });
}

function applyPreviewBarIframeTitle(root = document) {
  const iframe = root.querySelector('#PBarNextFrame');
  if (!iframe) return;
  if (!iframe.getAttribute('title')) {
    iframe.setAttribute('title', 'Shopify preview bar');
  }
}

function fixYotpoMediaButtonLabel(button) {
  if (!(button instanceof HTMLElement)) return;
  // Remove verbose aria-label from Yotpo review image buttons
  // Visible text is just the count (e.g., "+1"), not the verbose description
  if (button.hasAttribute('aria-label')) {
    button.removeAttribute('aria-label');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  applyKlaviyoFieldLabels();
  applyYotpoBadgeA11y();
  applyYotpoReadMoreLabels();
  applyYotpoCarouselArrowLabels();
  applyPreviewBarIframeTitle();

  // Fix Yotpo media button aria-labels
  const mediaButtons = document.querySelectorAll('button.yotpo-media-button');
  mediaButtons.forEach(fixYotpoMediaButtonLabel);

  if (!document.body || !window.MutationObserver) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches('[class*="klaviyo-form"]')) {
          applyKlaviyoFieldLabels(node);
          return;
        }

        if (node.querySelector && node.querySelector('[class*="klaviyo-form"]')) {
          applyKlaviyoFieldLabels(node);
        }

        if (node.matches('svg.yotpo-shop-badge, svg.yotpo-answers-extra-arrow, svg.PREV, svg.NEXT')) {
          applyYotpoBadgeA11y(node.parentElement || document);
          return;
        }

        if (
          node.querySelector &&
          node.querySelector('svg.yotpo-shop-badge, svg.yotpo-answers-extra-arrow, svg.PREV, svg.NEXT, .yotpo-pagination-icon')
        ) {
          applyYotpoBadgeA11y(node);
        }

        if (node.matches('button.yotpo-read-more')) {
          applyYotpoReadMoreLabels(node.parentElement || document);
          return;
        }

        if (node.querySelector && node.querySelector('button.yotpo-read-more')) {
          applyYotpoReadMoreLabels(node);
        }

        if (node.matches('.yotpo-carousel-arrow')) {
          applyYotpoCarouselArrowLabels(node.parentElement || document);
          return;
        }

        if (node.querySelector && node.querySelector('.yotpo-carousel-arrow')) {
          applyYotpoCarouselArrowLabels(node);
        }

        if (node.matches('#PBarNextFrame')) {
          applyPreviewBarIframeTitle(node.parentElement || document);
          return;
        }

        if (node.querySelector && node.querySelector('#PBarNextFrame')) {
          applyPreviewBarIframeTitle(node);
        }

        if (node.matches('button.yotpo-media-button')) {
          fixYotpoMediaButtonLabel(node);
          return;
        }

        if (node.querySelector && node.querySelector('button.yotpo-media-button')) {
          const mediaButtons = node.querySelectorAll('button.yotpo-media-button');
          mediaButtons.forEach(fixYotpoMediaButtonLabel);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});